export const compose = (...fns) => fns.reduce(
  (f, g) => (...args) => f(g(...args))
);



// WEBPACK FOOTER //
// ./src/redux-utils/funcs.js